import React, { useState } from 'react';
import Card from '../Card/Card';
import ShowMore from '../../Atoms/ShowMore/ShowMore';
import { Loading, TextInput } from '@osttra/ds-react';
import cardPropsType, { appUsersPropsType } from '../../../propsType';
import './CardSession.css';

const CardSession = (props: {
  userMapping: cardPropsType;
  customTargetRedirectURL: string | undefined;
  searchData: appUsersPropsType[];
  appUsers: appUsersPropsType[] | null;
  searchFunData: Function;
  urlAppId: string;
}) => {
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setSearchValue(newValue);

    const query = newValue.toUpperCase().trim();

    if (!Array.isArray(props.appUsers)) {
      return;
    }

    if (!newValue) {
      props.searchFunData(props.appUsers);
      return;
    }

    const filteredUsers = props.appUsers.filter(
      (user) => user?.userId?.toUpperCase()?.includes(query) || user?.organization?.toUpperCase()?.includes(query)
    );

    if (filteredUsers.length > 0) {
      props.searchFunData(filteredUsers);
    } else {
      props.searchFunData({});
    }
  };

  return (
    <>
      {Array.isArray(props.userMapping.appUsers) && props.userMapping.appUsers.length > 1 ? (
        <>
          <div className="t-flex t-justify-end">
            <TextInput
              type="search"
              placeholder="Search"
              data-testid="searchInput"
              value={searchValue}
              onChange={handleSearch}
              aria-label="Search Box"
              icon="search"
            />
          </div>
          <section>
            <div
              className={`card ${
                Array.isArray(props.userMapping.appUsers) && props.userMapping.appUsers.length < 11
                  ? 'showMoreActive'
                  : ''
              }`.trim()}
            >
              <div className="t-grid storybook-grid-demo">
                {Array.isArray(props.searchData) && props.searchData ? (
                  props.searchData.map((items: appUsersPropsType, index: number) => {
                    return (
                      <Card
                        userId={items.userId}
                        customTargetRedirectURL={props.customTargetRedirectURL}
                        appName={props.userMapping.appName}
                        organization={items.organization}
                        key={index}
                        urlAppId={props.urlAppId}
                      />
                    );
                  })
                ) : (
                  <div className="searchErrorMsg t-p-l t-text-left">
                    <h2>Sorry, we couldn’t find any matches. </h2>
                    <p>Please try to change your keyword.</p>
                  </div>
                )}
              </div>
            </div>
            <ShowMore userMapLength={props.userMapping.appUsers.length} />
          </section>
        </>
      ) : (
        <div className="LoadingText">
          <h1 className="t-mt-e">Please wait it's processing...</h1>
          <Loading size={'big'} />
        </div>
      )}
    </>
  );
};

export default CardSession;
